import { Component, ErrorInfo, ReactNode } from 'react'
import { getPlatformService } from '../services/PlatformService'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class PlatformErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('PlatformErrorBoundary caught an error:', error, errorInfo)

    // 根据平台记录错误
    const platformService = getPlatformService()
    if (platformService.isDesktop()) {
      // 桌面版：记录到本地日志（可以后续实现文件日志）
      console.error('Desktop error:', error, errorInfo)
    } else {
      // Web版：可以发送到错误追踪服务
      console.error('Web error:', error, errorInfo)
      // 可以在这里调用错误追踪服务
      // sendErrorToServer(error, errorInfo)
    }
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <div className="flex items-center justify-center h-screen bg-gray-50">
          <div className="text-center p-8 bg-white rounded-lg shadow-lg max-w-md">
            <h2 className="text-2xl font-bold text-red-600 mb-4">出现错误</h2>
            <p className="text-gray-700 mb-4">
              {this.state.error?.message || '发生了未知错误'}
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null })
                window.location.reload()
              }}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              重新加载
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

